import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { isSelectableItem, Item, SelectableItem } from "src/services/item/item.interface";
import { NavigationService } from "src/services/navigation/navigation.service";
import { EditingMode } from "../../../../shared/editing.const";

@Component({
  selector: "rc-item-list",
  templateUrl: "./item-list.component.html",
  styleUrls: ["./item-list.component.scss"],
  standalone: false,
})
export class ItemListComponent implements OnChanges {
  @Input() public items: Item[] | SelectableItem[];
  @Input() public mode: EditingMode = "read";
  @Input() public showScanButton: boolean = false;
  @Input() public showStatus: boolean = true;
  @Input() public withItemStatus: boolean;

  @Output() onSelect = new EventEmitter<string>();
  @Output() onDeselect = new EventEmitter<string>();

  public internalItems: SelectableItem[];

  constructor(public readonly navigationService: NavigationService) {}

  public ngOnChanges(): void {
    this.internalItems = this.items.map((item: Item | SelectableItem) => {
      if (isSelectableItem(item)) {
        return item;
      } else {
        return {
          ...item,
          selected: false,
        };
      }
    });
  }

  public onClickDeselect(itemId: string): void {
    this.onDeselect.emit(itemId);
  }

  public onClickSelect(itemId: string): void {
    this.onSelect.emit(itemId);
  }
}
